import { Box, Card, CardActionArea, Typography } from "@mui/material";
import NV0 from "../../assets/NV0.png";
import NV1 from "../../assets/NV1.png";
import NV2 from "../../assets/NV2.png";
import NV3 from "../../assets/NV3.png";
import React, { useEffect, useState } from "react";
import { FlowTipo } from "../../context/FluxogramaContext";
import { BarragemFluxogramas, useBarragemContext } from "../../context";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog, LoadingModal } from "../../components";
import { useNavigate } from "react-router-dom";

export const Fluxogramas: React.FC = () => {
  const navigate = useNavigate();
  const { barragem, setBarragem } = useBarragemContext();
  const api = useApi();

  const [error, setError] = useState<RequestError>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    if ("error" in barragem.fluxogramas) {
      setError(barragem.fluxogramas);
      return;
    }
  }, [barragem]);

  const handleOpenFlow = async (tipo: FlowTipo) => {
    if (!barragem || "error" in barragem) return;
    if (barragem.fluxogramas && "error" in barragem.fluxogramas) return;

    setLoading(true);

    let nv: ("NV0" | "NV1" | "NV2" | "NV3") = "NV0";
    if (tipo === 'Nível 1') nv = "NV1";
    else if (tipo === 'Nível 2') nv = "NV2";
    else if (tipo === "Nível 3") nv = "NV3";

    let flowId = barragem.fluxogramas[nv];
    if (!flowId) {
      const flow = await api.fluxogramas.addFlow(tipo, tipo, barragem.id);
      if ("error" in flow) {
        setError(flow);
        setLoading(false);
        return;
      }

      flowId = flow.id;

      const fluxogramas: BarragemFluxogramas = barragem.fluxogramas;
      if (nv === "NV0") {
        fluxogramas.NV0 = flowId;
      } else if (nv === "NV1") {
        fluxogramas.NV1 = flowId;
      } else if (nv === "NV2") {
        fluxogramas.NV2 = flowId;
      } else if (nv === "NV3") {
        fluxogramas.NV3 = flowId;
      }

      setBarragem({
        ...barragem,
        fluxogramas: fluxogramas
      });
    }

    setLoading(false);
    navigate(`/app/${barragem.id}/fluxograma/${nv}`);
  };

  return <>
    <LoadingModal open={loading} />

    <ErrorOnDialog
      open={Boolean(error)}
      error={error?.error ?? ""}
      message={error?.message ?? ""}
      onClose={() => setError(undefined)}
    />
    <Box sx={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: 'column',
      alignItems: "center",
      justifyContent: 'center',
      gap: "2em",
    }}>
      <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
        <ClickableCard
          imageUrl={NV0}
          title="Alerta"
          onClick={() => handleOpenFlow('Nível de alerta')}
        />
        <ClickableCard
          imageUrl={NV1}
          title="Nível 1"
          onClick={() => handleOpenFlow("Nível 1")}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
        <ClickableCard
          imageUrl={NV2}
          title="Nível 2"
          onClick={() => handleOpenFlow("Nível 2")}
        />
        <ClickableCard
          imageUrl={NV3}
          title="Nível 3"
          onClick={() => handleOpenFlow("Nível 3")}
        />
      </div>
    </Box>
  </>;
};

interface ClickableCardProps {
  title: string;
  imageUrl: string;
  onClick: () => void;
}
const ClickableCard: React.FC<ClickableCardProps> = ({ title, imageUrl, onClick }) => {
  return (
    <Box sx={{
      width: '200px',
      margin: '16px',
      textAlign: 'center'
    }}>

      {/* Texto abaixo do card */}
      <Typography
        variant="subtitle1"
        fontWeight='bold'
        textAlign='center'
        sx={{
          mt: 1,
          fontWeight: 'medium',
          color: 'text.primary',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {title}
      </Typography>

      {/* Card com imagem */}
      <Card
        sx={{
          width: 200,
          height: 200,
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          transition: 'transform 0.3s, box-shadow 0.3s',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
          }
        }}
      >
        <CardActionArea
          onClick={onClick}
          sx={{
            width: '100%',
            height: '100%',
            padding: 0
          }}
        >
          {/* Imagem de fundo que ocupa todo o card */}
          <Box
            sx={{
              width: '100%',
              height: '100%',
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              alignItems: 'flex-end', // Alinha o conteúdo no rodapé
            }}
          />
        </CardActionArea>
      </Card>
    </Box>
  );
};